import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware((to, from) => {
  const orderCookie = useCookie("order");

  if (to.path === paths.processingTransaction && !orderCookie.value) {
    return navigateTo(paths.cart);
  }

  if (to.path === paths.orderPlaced && !orderCookie.value) {
    return navigateTo(paths.cart);
  }

  if (
    to.path === paths.paymentPending &&
    from.path !== paths.processingTransaction
  ) {
    return navigateTo(paths.cart);
  }
});
